/* global _DEBUG */

import { captureException } from '@sentry/browser';
import { selectCurrentCustomDomain } from './location/selectors';

export const decorateAction = (
  customDomains,
  currentCustomDomain,
  routesMap,
  action
) => {
  if (
    Object.keys(routesMap).indexOf(action.type) !== -1 &&
    routesMap[action.type].injectInstitutionPrefix
  ) {
    let currentCustomDomainInstitution;
    if (currentCustomDomain !== null) {
      try {
        currentCustomDomainInstitution = customDomains
          .find((entry) => entry.get('domain') === currentCustomDomain)
          .get('path');
      } catch (e) {
        /**
         * If we are on the wrong domain, don't crash.
         * Its useful for e.g. https://auweb9.openlearning.com
         */
        if (!_DEBUG) {
          captureException(e);
        }
      }
    }

    if (action.location && action.location.kind === 'load') {
      /**
       * This covers actions dispatched from the page load instead
       * of from redux actions
       */
      if (currentCustomDomainInstitution) {
        /**
         * On custom domains, we fill in `state.institutionPrefix`
         * to match the current domain.
         */
        return {
          ...action,
          state: {
            ...action.state,
            institutionPrefix: currentCustomDomainInstitution,
          },
        };
      }

      /**
       * On the OL domain, we fill in the `state.institutionPrefix` to match the URL params.
       */
      return {
        ...action,
        state: {
          ...action.state,
          institutionPrefix: action.params.institutionPrefix,
        },
      };
    }

    /**
     * When actions are dispatched programatically, we expect the
     * `state.institutionPrefix` to represent the intended institution.
     * We have to fill in the params to suit if the action can change the URL
     * without a page reload.
     */
    if (
      action.state &&
      action.state.institutionPrefix &&
      !currentCustomDomainInstitution
    ) {
      return {
        ...action,
        params: {
          ...action.params,
          institutionPrefix: action.state.institutionPrefix,
        },
      };
    }
  }
  return action;
};

export const institutionPrefixMiddleware = (customDomains, routesMap) => (
  store
) => (next) => (action) => {
  const currentCustomDomain = selectCurrentCustomDomain(store.getState());
  return next(
    decorateAction(customDomains, currentCustomDomain, routesMap, action)
  );
};
